/**
 * @description Keeps track of the filter state applied to the contract assignment page
 */

import React from 'react';
import { PropTypes } from 'prop-types';

export const FiltersContext = React.createContext(null);
export const SetFiltersContext = React.createContext(() => { /* do nothing */ });

export const FiltersProvider = ({ children }) => {
  const [filters, setFilters] = React.useState(null);

  return (
    <SetFiltersContext.Provider value={setFilters}>
      <FiltersContext.Provider value={filters}>
        {children}
      </FiltersContext.Provider>
    </SetFiltersContext.Provider>
  );
};

FiltersProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};
